import { Injectable } from '@angular/core';
import { RolService } from './rol.service';
import { Usuario } from 'src/app/models/entities/usuario';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';
import { Observable, from } from 'rxjs';
import { switchMap, map, toArray, take, concatMap } from 'rxjs/operators';
import { UsuarioRol } from 'src/app/models/entities/usuario-rol';
import { UsuarioSesionDTO } from 'src/app/models/dtos/usuario-sesion-dto';
import { Rol } from 'src/app/models/entities/rol';
import { UsuarioRolService } from './usuario-rol.service';
import { UsuarioService } from './usuario.service';
import { RolFuncionalidadService } from './rol-funcionalidad.service';
import { CatalogoService } from './catalogo.service';
import { RolFuncionalidad } from '../models/entities/rol-funcionalidad';
import { RutaCatalogoEnum } from '../shared/enums/ruta-catalogo.enum';
import { Funcionalidad } from '../models/entities/funcionalidad';

@Injectable({
  providedIn: 'root'
})
export class FacadeUsuarioService {

  constructor(
    private usuarioService: UsuarioService,
    private usuarioRolService: UsuarioRolService,
    private rolService: RolService,
    private rolFuncionalidadService: RolFuncionalidadService,
    private catalogoService: CatalogoService
  ) { }

  public obtenerDatosUsuario(correoUsuario: string): Observable<UsuarioSesionDTO> {
    return this.usuarioService.findByCorreo(correoUsuario)
      .pipe(
        switchMap((usuario: Usuario) => this.usuarioRolService.findByKeyUsuario(usuario.key)
          .pipe(
            switchMap((usuarioRol: UsuarioRol) => this.rolService.findByKeyRol(usuarioRol.keyRol)
              .pipe(
                concatMap((rol: Rol) => this.rolFuncionalidadService.findByKeyRol(rol.key)
                  .pipe(
                    concatMap((rolesFuncionalidades: RolFuncionalidad[]) => this.catalogoService.obtenerCatalogo<Funcionalidad>(RutaCatalogoEnum.FUNCIONALIDADES)
                      .pipe(
                        map((catFuncionalidades: Funcionalidad[]) => {
                          let funcionalidades: Funcionalidad[] = [];
                          rolesFuncionalidades.forEach((rolFuncionalidad: RolFuncionalidad) => {
                            let funcionalidad: Funcionalidad = catFuncionalidades.find((f: Funcionalidad) => f.key === rolFuncionalidad.keyFuncionalidad);
                            if (funcionalidad) {
                              funcionalidades.push(funcionalidad);
                            }
                          })
                          return ({ usuario, rol, funcionalidades }) as UsuarioSesionDTO;
                        })
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
  }

  public obtenerUsuariosConSuRol(): Observable<UsuarioSesionDTO[]> {
    return this.usuarioService.findAll()
      .pipe(
        concatMap((usuarios: Usuario[]) => from(usuarios)
          .pipe(
            concatMap((usuario: Usuario) => this.usuarioRolService.findByKeyUsuario(usuario.key)
              .pipe(
                concatMap((usuarioRol: UsuarioRol) => this.rolService.findByKeyRol(usuarioRol.keyRol)),
                take(1),
                map((rol: Rol) => ({ usuario, rol } as UsuarioSesionDTO)),
              )),
            toArray()
          )
        )
      );

  }
}
